import { Vector2 } from "./Vector2";

export class Line2 {
    
    constructor(public start: Vector2, public end: Vector2) {
    }

    public angle(other: Line2): number {
        const angle = Math.atan2(this.end.y - this.start.y, this.end.x - this.start.x) - Math.atan2(other.end.y - other.start.y, other.end.x - other.start.x);
        return angle;
    }

    public intersection(other: Line2): Vector2 | undefined {
        const denominator = (this.start.x - this.end.x) * (other.start.y - other.end.y) - (this.start.y - this.end.y) * (other.start.x - other.end.x);
        if (denominator === 0) {
            return undefined;
        }

        let x = ((this.start.x * this.end.y - this.start.y * this.end.x) * (other.start.x - other.end.x) - (this.start.x - this.end.x) * (other.start.x * other.end.y - other.start.y * other.end.x)) / denominator;
        let y = ((this.start.x * this.end.y - this.start.y * this.end.x) * (other.start.y - other.end.y) - (this.start.y - this.end.y) * (other.start.x * other.end.y - other.start.y * other.end.x)) / denominator;

        x = Object.is(x, -0) ? 0 : x;
        y = Object.is(y, -0) ? 0 : y;

        return new Vector2(x, y);
    }

    public length(): number {
        return Math.sqrt(Math.pow(this.end.x - this.start.x, 2) + Math.pow(this.end.y - this.start.y, 2));
    }

}